import { NgModule } from '@angular/core';
import { Http, HttpModule, RequestOptions } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule, NgbTypeaheadModule} from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthGuard } from './shared';
import { ConstantComponent } from './constant.component';
import { ValidationService } from './GenericService/validation.service';
import {HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';
import {  NO_ERRORS_SCHEMA } from '@angular/core';
import { SidebarModule } from 'ng-sidebar';
import { AppHttpInterceptor } from './Interceptor/httpInterceptor';
import { NgxImageZoomModule } from 'ngx-image-zoom';

import { NgIdleKeepaliveModule } from '@ng-idle/keepalive'; // this includes the core NgIdleModule but includes keepalive providers for easy wireup
import { CommanService } from './shared/comman/comman.service';
import { ServiceListComponent } from './service-list/service-list.component';
import { FormsModule } from '@angular/forms';

@NgModule({
    declarations: [
        AppComponent,
        ConstantComponent,
        ValidationService,
        ServiceListComponent,
        
        
        
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpModule,
        HttpClientModule,
        AppRoutingModule,
        FormsModule,
        NgbModule.forRoot(),
        SidebarModule.forRoot(),
        NgxImageZoomModule.forRoot(),
        NgIdleKeepaliveModule.forRoot(),
    ],
    providers: [AuthGuard,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AppHttpInterceptor,
            multi: true
          },
          CommanService
    ],
    bootstrap: [AppComponent],
    schemas: [ NO_ERRORS_SCHEMA ]
})
export class AppModule {
}
